import axiosInstance from './axiosConfig'

const BVDocumentAPI = {
  getById: function ({ org_id, folder_id, submission_id, document_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/documents/${org_id}/${folder_id}/${submission_id}/${document_id}`,
    })
  },
  validate: function ({ org_id, folder_id, submission_id, document_id }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/documents/${org_id}/${folder_id}/${submission_id}/${document_id}/validate`,
      data: { validate: true },
    })
  },
  verify: function ({ org_id, folder_id, submission_id, document_id }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/documents/${org_id}/${folder_id}/${submission_id}/${document_id}/verify`,
    })
  },
  reject: function ({ org_id, folder_id, submission_id, document_id, note }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/documents/${org_id}/${folder_id}/${submission_id}/${document_id}/reject`,
      data: { note },
    })
  },
  reset: function ({ org_id, folder_id, submission_id, document_id }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/documents/${org_id}/${folder_id}/${submission_id}/${document_id}/reset`,
    })
  },
  previewDocument: function ({ org_id, folder_id, submission_id, file_id }) {
    return axiosInstance
      .request({
        method: 'GET',
        url: `/files/${org_id}/${folder_id}/${submission_id}/${file_id}/document`,
        responseType: 'blob',
      })
      .then(res => {
        return { data: new Blob([res.data], { type: res.data?.type }) }
      })
  },
  previewImage: function ({ org_id, folder_id, submission_id, page_id }) {
    return axiosInstance
      .request({
        method: 'GET',
        url: `/submissions/${org_id}/${folder_id}/${submission_id}/pages/${page_id}/photo`,
        responseType: 'blob',
      })
      .then(res => {
        if (res.data?.type.indexOf('image') === -1) {
          return null
        }
        return { data: new Blob([res.data], { type: res.data?.type }) }
      })
  },
}

export default BVDocumentAPI
